<rt-box layout-vertical [attr.data-cy]="'share-on-the-go-dialog:user-item:' + user.id">
  <div layout layout-align-items-center>
    <rt-avatar
      [imageSrc]="user.photoThumbUrl"
      [initials]="user.initials"
      [shape]="'oval'"
      [size]="'base'"
      [type]="user.hasAvatar ? 'image' : 'initials'"
      context="admin"
    ></rt-avatar>
    <div layout-vertical margin-left-small>
      <rt-heading>
        <rt-truncate> {{ user.firstName }} {{ user.lastName }} </rt-truncate>
      </rt-heading>
      <span>{{ user.roleName }}</span>
    </div>
  </div>
  @if (accessOptionsConfig) {
    <div layout-vertical>
      <rt-divider margin-top-medium margin-bottom></rt-divider>
      <rt-radio-form-group [items]="options" [formControl]="selectedOption!"></rt-radio-form-group>
    </div>
  }
</rt-box>

<ng-template #radioTpl let-item>
  <div layout layout-align-items-center>
    <rt-radio-form-group-item
      [item]="item"
      [disabled]="!isOptionEnabled(item)"
      [rtTooltip]="
        'app.candidate.share_on_the_go.allow_access_to_candidate.no_option_access' | translate
      "
      [rtTooltipEnabled]="!isOptionEnabled(item)"
      rtTooltipPosition="left"
      (click)="!isOptionEnabled(item) ? $event.stopPropagation() : null"
      layout-full-width
    ></rt-radio-form-group-item>
  </div>
</ng-template>

<ng-template #radioWithInfoIconTpl let-item>
  <div layout layout-align-items-center>
    <rt-radio-form-group-item [item]="item"></rt-radio-form-group-item>
    <rt-icon
      [rtTooltip]="
        shareOnTheGoI18n.dontRequestOptionTooltip | translate: { userFirstName: user.firstName }
      "
      [rtTooltipHasTextAlignCenter]="true"
      name="info-outline"
      margin-left-small-x
      data-cy="share-on-the-go-dialog:icon-with-tooltip"
    ></rt-icon>
  </div>
</ng-template>
